import { useState } from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { EditCaseForm } from '@/modules/projects/components/case'
import { useDialogActions, useDialogIsOpen } from '@/stores/dialog'

const dialogId = 'edit-case'

export const EditCaseDialog = () => {
  const open = useDialogIsOpen(dialogId)
  const { closeDialog } = useDialogActions()
  const [isSaving, setIsSaving] = useState(false)

  // A save in flight owns the dialog: closing it would toast over a page the
  // user already moved on from, with no form left to retry in.
  const requestClose = () => {
    if (!isSaving) closeDialog()
  }

  return (
    <Dialog open={open} onOpenChange={(next) => !next && requestClose()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Case details</DialogTitle>
          <DialogDescription>
            The kind of matter and the facts behind it. Every field is optional
            and can be changed later.
          </DialogDescription>
        </DialogHeader>
        <EditCaseForm
          isSaving={isSaving}
          onSavingChange={setIsSaving}
          onClose={closeDialog}
        />
      </DialogContent>
    </Dialog>
  )
}

EditCaseDialog.id = dialogId
